// Single task run by ID — TanStack Query hook

import { useQuery } from "@tanstack/react-query";
import { api, withClientTimeout } from "../lib/api";
import type { TaskRun } from "../../../shared/types";

export function useRun(runId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ["task-run", runId],
    queryFn: () =>
      withClientTimeout((signal) => api.get<{ data: TaskRun }>(`/api/task-runs/${encodeURIComponent(runId!)}`, signal)),
    enabled: !!runId && enabled,
    staleTime: 10_000,
    retry: false,
    // Poll every 3s while run is active; stop once terminal (completed/failed/retried)
    refetchInterval: (query) => {
      const status = query.state.data?.data?.status;
      return status === "running" || status === "retrying" ? 3000 : false;
    },
  });
}
